import ServiceFactory from '../../service_factory';
import {ILogClientData} from '../interfaces/log-client-data.interface';

export class LogClientDataBuilder {
    constructor(private readonly services: ServiceFactory) {
    }

    build(): ILogClientData {
        let skinService = this.services.skinService();
        let clientData:ILogClientData= {
            version: skinService.getVersion(),
            brand: skinService.getBrandID(),
            subBrand: skinService.getSubBrandID(),
            productPackage: skinService.getProductPackageID(),
            language: this.services.languageService().getISO3(),
            regulationCode: this.services.regulationService().getRegulationCode(),
            browserTabId: this.services.gameService().getBrowserTabId()
        };
        let parentProductPackage = this.services.oAuth2Service().getSourceProductPackage();
        if(parentProductPackage) {
            clientData.parentProductPackage = parentProductPackage;
        }

        return clientData;
    }
}
